export const PILOT_COMPONENTS_CARD_FRENCH_LOCALE = {
  title: "Composants du pilote",
};
